import { Card, Typography, Empty } from 'antd';

export function Usage() {
  // Phase 5 will wire up CloudWatch metrics + usage_events aggregation.
  return (
    <Card>
      <Typography.Title level={3}>Usage</Typography.Title>
      <Empty description="Usage analytics arrive in the next release." />
    </Card>
  );
}
